const textBackgroundToggle = (state = false, action)=>{
    if(action.type === "SET_BG_TOGGLE"){
        state = action.state
    }
    return state;
}

export default textBackgroundToggle;